import { type RootState } from "../../../../Application/globaltypes/redux";
import { createSelector } from "@reduxjs/toolkit";
import { mapTagsToView } from "../../../Common/helpers/tagsHelper";
import { type TagsPayloadCamelPlural } from "../../../../../interfaces/Tags";

export const eventsTagsSelector = createSelector(
  [(state: RootState): TagsPayloadCamelPlural => state.library.events.common.tags],
  mapTagsToView,
);
